import {instance, IResponse} from "@shared/api/axiosInstance";
import {IResponseUserData, IUserData, IUserRegistrationData} from "./authStore";


export const authAPI = {
    register(user: IUserRegistrationData) {
        return instance.post<IResponse<IResponseUserData>>(`auth/register`, user).then(res => res.data)
    },
    checkingExistNickname(nickname) {
        return instance.get<IResponse<string>>(`users/${nickname}/checking`).then(res => res.data)
    },
    generateRegistrationKey() {
        return instance.post<IResponse<string[]>>(`registrationKeys`).then(res => res.data)
    },
    getRegistrationKeys() {
        return instance.get<IResponse<string[]>>(`registrationKeys`).then(res => res.data)
    },
    deleteRegistrationKey(key) {
        return instance.delete<IResponse<string[]>>(`registrationKeys/${key}/delete`).then(res => res.data)
    },
    checkingValidKey(key) {
        return instance.get<string>(`registrationKeys/${key}/checking`).then(res => res.data)
    },
    getStatusCheckedCaptcha(token) {
        return instance.post<IResponse<{
            status: string, message: string, host: string
        }>>(`auth/captcha`, {token}).then(res => res.data)
    },
    login(user: IUserData){
        return  instance.post<IResponse<IResponseUserData>>(`auth/login`, user).then(res => res.data)

    },
    fixIp() {
        return instance.post(`auth/fix`)
    },
    checkIp() {
        return instance.get(`auth/check`).then(res => res.data)
    },
}